<div class="site-page-header-ghost-wrapper">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title class="ml4">Delete Requests</nz-page-header-title>
  </nz-page-header>
</div>

<div nz-row nzJustify="end" class="mt4">
  <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24" class="mb5">
    <nz-form-label nzFor="search">Search</nz-form-label>
    <nz-input-group [nzSuffix]="suffixIconSearch">
      <input
        type="text"
        nz-input
        placeholder="Search by name, email, mobile"
        ngModel
        (ngModelChange)="searchDeleteRequests($event)"
      />
    </nz-input-group>
    <ng-template #suffixIconSearch>
      <i nz-icon nzType="search"></i>
    </ng-template>
  </div>
</div>

<!-- Delete Requests Table -->
<nz-table
  #deleteReqTable
  [nzData]="deleteRequests"
  [nzLoading]="loading"
  [nzTotal]="totalDataCount"
  [(nzPageSize)]="pageSize"
  [nzPageIndex]="pageIndex"
  [nzFrontPagination]="false"
  (nzQueryParams)="onQueryParamsChange($event)"
  nzShowSizeChanger
  [nzScroll]="{ x: '1000px' }"
>
  <thead>
    <tr>
      <th nzColumnKey="name" [nzSortFn]="true">User Name</th>
      <th>Email</th>
      <th>Mobile</th>
      <th nzWidth="200px">Reason</th>
      <th nzWidth="150px">Request Date</th>
      <th nzWidth="100px">Personal Info</th>
      <th class="text-right" nzWidth="200px">Action</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let data of deleteReqTable.data">
      <td>{{ data.name }}</td>
      <td>{{ data.email }}</td>
      <td>{{ data.mobile }}</td>
      <td>
        <span nz-tooltip [nzTooltipTitle]="data.reason">
          {{ data.reason | slice: 0 : 20
          }}{{ data.reason.length > 20 ? "..." : "" }}
        </span>
      </td>
      <td>{{ data.createdAt | date: "mediumDate" }}</td>
      <td class="text-center">
        <nz-tag [nzColor]="data.isCheckPersonalInfo ? 'green' : 'red'">
          {{ data.isCheckPersonalInfo ? "Yes" : "No" }}
        </nz-tag>
      </td>
      <td class="action-buttons">
        <a
          nz-button
          nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to accept this delete request?"
          (nzOnConfirm)="acceptDeleteRequest(data._id, true)"
          nzTooltipTitle="Accept"
          nzTooltipPlacement="topCenter"
          nz-tooltip
        >
          <i nz-icon nzType="check" nzTheme="outline"></i>
        </a>
        <a
          class="action-button delete"
          nz-button
          nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to reject this delete request?"
          (nzOnConfirm)="acceptDeleteRequest(data._id, false)"
          nzTooltipTitle="Reject"
          nzTooltipPlacement="topCenter"
          nz-tooltip
        >
          <i nz-icon class="reject-btn" nzType="close" nzTheme="outline"></i>
        </a>
      </td>
    </tr>
  </tbody>
</nz-table>
